export class AssetFileSpecification{
    public fileType : String;
    public fileQuality: Number;
    public fileFormat: String;
    public textureQuality: Number;
    public rigged: Boolean;
    public animation: Boolean;
    public spin: Boolean;
    public movementLogic: Boolean;
    public interaction: Boolean;
    public userInteraction: Boolean;
    public joystickInteraction: Boolean;
    public automaticallyUpdateViaGit: Boolean;
    public polygonCount: Number;
}